import { useState, useContext, useEffect } from 'react';
import { InputConfig } from '../../Context/InputConfig';



// export const GetCropData = (config) => {
//     const crops = []
//     Object.keys(config.interests).forEach(cropId => {
//         var currentCrop = config.cropsInterest[cropId];
//         const products = []
//         config.interests[cropId].forEach((productId) => {
//             var currentProduct = config.productsInterest[productId];
//             products.push({ id: productId.toString(), name: currentProduct.name, isChecked: false })
//         })
//         crops.push({ id: cropId, name: currentCrop.name, isChecked: false, products: products })
//     })
//     return crops
// }

const UseForm = ({ submit, validate, formData, setFormData, setDisableSubmit, customValidations }) => {

    const { consentData, provinces, acceptTAndC, acceptCEM,contactMe} = useContext(InputConfig);
    
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState({});


    const handleChange = (event) => {

        const { name, value, type, checked, id } = event.nativeEvent.target
        var inputValue = value;
     

        if (type === 'text') {
            if (id === 'phone') {
                inputValue = (/\d/.test(value)) ? value.match(/\d/g).join("").substring(0, 10) : '';
            }
            setFormData({ ...formData, [id]: (inputValue) })
        } else if (type === 'checkbox') {

            var cropIndex = 0

            if (event.nativeEvent.target.attributes.listtype !== undefined) {

                let interests = [...formData.interests]
                const { name, listtype, cropid } = event.nativeEvent.target.attributes

                if (listtype.value === 'crop') {
                    var selectedCrop = interests.find((crop, index) => {
                        if (crop.id === name.value) {
                            cropIndex = index
                            return true
                        }
                        return false
                    })
                    selectedCrop.isChecked = event.value
                    var products = selectedCrop.products.map(product => ({ ...product, isChecked: event.value }))
                }
                else {
                    selectedCrop = interests.find((crop, index) => {
                        if (crop.id === cropid.value) {
                            cropIndex = index
                            return true
                        }
                        return false
                    })

                    products = selectedCrop.products.map(product => {
                        return name.value === product.id ? { ...product, isChecked: event.value } : product
                    })
                }

                selectedCrop.isChecked = products.every(product => product.isChecked)
                selectedCrop.products = products
                interests.splice(cropIndex, 1, selectedCrop)

                setFormData({ ...formData, interests: interests })

            } else {
                setFormData({ ...formData, [name]: checked })
            }
        } else if (event.target.props.inputtype) {
            if (event.target.props.inputtype === 'select') {
                const inputName = event.target.props.name
                setFormData({ ...formData, [inputName]: event.value.id })
            }
        }
     

    }

    const handleBlur = (event) => {
        setErrors(validate(formData, customValidations));
    }

    const handleSubmit = (event) => {

        // setDisableSubmit(true);
        event.preventDefault();
        setErrors(validate(formData, customValidations))
        setIsSubmitting(true)
    };

 
    useEffect(() => {
        if (Object.keys(errors).length === 0 && isSubmitting) {
            submit()
            setIsSubmitting(false)
        }
        else {
            // setDisableSubmit(false)
        }
    }, [errors, isSubmitting, submit])

    return {
        handleChange, handleSubmit,handleBlur, errors, consentData, acceptCEM, provinces, acceptTAndC,contactMe
    };
}

export default UseForm;